'use strict';

import {SectionCtrl} from "./sectionctrl.js";

export class SectionBaseCtrl extends SectionCtrl
{
	
}

